const o = "scalar-tooltip", t = "scalar-tooltip", E = 300;
export {
  E as DEFAULT_DELAY,
  t as ELEMENT_CLASS,
  o as ELEMENT_ID
};
